import {Widget} from "base/assets/js/widget/Widget.js";
import {Form} from "brigada/src/widget/Form.js";
import {CNavs} from "base/assets/js/widget/CNavs.js";

export class CommForm extends Widget {

	_bPreview = false;
	_bPlaceholder = true;
	_bEmpty = true;
	_iTopicId;
	_iReplyTo = 0;
	_iCommentId = 0;
	_iLev = 1;
	_eBaseParent;

	run() {

		this._my( { 'topic-id': '_iTopicId' } );
		this._eBaseParent = this.bl().parentElement;

		// переключение режим - предпросмотр/редактор
		this._on( 'PreviewBtn', 'click', () => {
			this._bPreview = !this._bPreview;

			if( this._bPreview ) {
				this._el( 'Preview' ).innerHTML = this._el( 'Editor' ).innerHTML;
			}
			this.refresh();
		} );

		// placeholder на редакторе
		this._on( 'Editor', 'keyup', ::this._placeholder );
		this._on( 'Editor', 'click', ::this._placeholder );
		this._on( 'Editor', 'blur', ::this._placeholder );
		this._on( 'Editor', 'focus', ::this._placeholder );
		this._on( 'Editor', 'textChange', ::this._placeholder ); // from Editor
		this._on( 'PlaceHolder', 'click', ::this.focus );

		this._on( 'PostBtn', 'click', () => {
			const oFormData = new FormData();
			oFormData.append( 'Comment[topic_id]', this._iTopicId );
			oFormData.append( 'Comment[reply_to]', this._iReplyTo || '' );
			oFormData.append( 'Comment[id]', this._iCommentId );
			oFormData.append( 'CommentSrc[src_html]', this._el( 'Editor' ).innerHTML.trim() );
			this.post( '/comment/create', oFormData )
				.then(
					( { iNewNum } ) => {
						this.reset();
						const oCNavs = this._rel().typeOf( CNavs ).find();
						oCNavs.select( iNewNum );
					},
					::this.ajaxPopupCatch
				);
		} );

		this._on( 'ResetBtn', 'click', () => {
			this.reset();
		} );
	}

	reset() {
		// если уехала форма, вернем на место
		if( this.bl().parentElement !== this._eBaseParent ) {
			this._eBaseParent.appendChild( this.bl() );
		}
		this._el( 'Editor' ).innerHTML = '';
		this._bPlaceholder = true;
		this._bEmpty = true;
		this._bPreview = false;
		this._iReplyTo = 0;
		this._iLev = 1;
		this.refresh();
	}

	refresh() {
		this._mod( '', 'cform_preview', this._bPreview );
		this._mod( '', 'cform_placeholder', this._bPlaceholder );
		this._mod( '', 'cform_empty', this._bEmpty );
		this._mod( '', 'cform_reply', !!this._iReplyTo );
		this.bl().setAttribute( 'data-lev', this._iLev );
	}

	focus() {
		this._bPlaceholder = false;
		this.refresh();
		this._el( 'Editor' ).focus();
	}

	setReplyTo( iReplyTo ) {
		this._iReplyTo = iReplyTo;
	}
	getReplyTo() {
		return this._iReplyTo;
	}

	setLev( iLev ) {
		this._iLev = iLev;
	}

	_placeholder() {
		const eEditor = this._el( 'Editor' );
		this._bEmpty = !eEditor.textContent && eEditor.childElementCount <= 1;
		this._bPlaceholder = !(eEditor === document.activeElement ) && this._bEmpty;
		this.refresh();
	}
}
